/**
 * PATH: packages/job-hub/src/jobs/qa/itpReportTitle.ts
 * FILE_ID: JOBHUB-QA-ITP-REPORT-TITLE-001
 * PURPOSE: Client-facing ITP title and Save As filename.
 * WHY: Empty stored title follows the client until the user types another.
 */

export function defaultItpReportTitle(clientName: string | null | undefined): string {
  const name = (clientName ?? '').trim()
  return name ? `Inspection Test Plan - ${name}` : 'Inspection Test Plan'
}

export function resolveItpReportTitle(
  stored: string | null | undefined,
  clientName: string | null | undefined,
): string {
  const title = (stored ?? '').trim()
  if (title) return title
  return defaultItpReportTitle(clientName)
}

export function itpPdfFilename(title: string): string {
  const cleaned = title
    .replace(/[\u0000-\u001f\u007f\\/:*?"<>|]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 120)
  return `${cleaned || 'Inspection Test Plan'}.pdf`
}

export function defaultItpAttachmentName(jobId: string | number, clientName: string): string {
  const client = (clientName || '')
    .replace(/[\u0000-\u001f\u007f\\/:*?"<>|]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
  const stem = (client ? `${jobId}_${client}_ITP` : `${jobId}_ITP`).slice(0, 116)
  return `${stem || 'ITP'}.pdf`
}
